import { AppShell, Burger, Group, Drawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar.tsx';
import { ThemeToggle } from './ThemeToggle.tsx';
import { UserMenu } from './UserMenu.tsx';
import { HeaderLeftSlot, HeaderRightSlot } from './HeaderSlot.tsx';

/**
 * App-wide shell. Slim blue header with a per-page LEFT slot (e.g. the
 * visitor-drawer toggle on Home), a per-page RIGHT slot (e.g. the role
 * selector on Home), and theme + user + hamburger controls anchored
 * far-right. No app title — the legacy doesn't show one and the user
 * specifically asked to remove it.
 */
export function Shell() {
  const [opened, { open, close }] = useDisclosure(false);
  return (
    <AppShell header={{ height: 56 }} padding="md">
      <AppShell.Header bg="blue.6" c="white" px="md">
        <Group h="100%" justify="space-between" wrap="nowrap">
          <Group gap="sm" wrap="nowrap">
            <HeaderLeftSlot />
          </Group>
          <Group gap="sm" wrap="nowrap">
            <HeaderRightSlot />
            <ThemeToggle />
            <UserMenu />
            <Burger opened={opened} onClick={open} aria-label="Open menu" color="white" />
          </Group>
        </Group>
      </AppShell.Header>

      <Drawer opened={opened} onClose={close} title="Menu" position="right" size={280}>
        <Navbar onNavigate={close} />
      </Drawer>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
